<template>
  <div class="step-content">
    <h3>CC Recipients</h3>
    <p class="step-description">
      Add additional email addresses to receive a copy of this notification.
    </p>

    <!-- CC Section -->
    <div class="cc-section">
      <div class="cc-header">
        <h4><i class="fa fa-envelope"></i> Additional Recipients</h4>
        <span class="cc-count">{{ ccEmails.length }} CC recipient(s)</span>
      </div>
      <div class="cc-input-group">
        <input
          type="email"
          :value="newCcEmail"
          @input="$emit('update:newCcEmail', $event.target.value)"
          placeholder="Enter email address (e.g., user@example.com)"
          class="cc-input"
          @keyup.enter="$emit('add-cc-email')"
        />
        <button
          type="button"
          class="btn btn-primary btn-sm"
          @click="$emit('add-cc-email')"
        >
          <i class="fa fa-plus"></i> Add
        </button>
        <button
          type="button"
          class="btn btn-secondary btn-sm"
          @click="$emit('select-response-team')"
          title="Select Response Team member(s)"
          disabled
        >
          <i class="fa fa-running"></i>
        </button>
      </div>
      <div v-if="ccEmails.length > 0" class="cc-list">
        <div
          v-for="(email, index) in ccEmails"
          :key="index"
          class="cc-item"
        >
          <span class="cc-email">{{ email }}</span>
          <button
            type="button"
            class="btn-remove-cc"
            @click="$emit('remove-cc-email', index)"
            title="Remove email"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
      <div v-else class="cc-empty">
        No additional CC recipients added. You can proceed without adding any CC recipients.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CCRecipientsStep",
  props: {
    ccEmails: { type: Array, required: true },
    newCcEmail: { type: String, required: true },
  },
};
</script>

<style scoped>
.step-content {
  padding: 20px;
}

.step-content h3 {
  margin-bottom: 10px;
  color: #1a73e8;
  font-size: 20px;
}

.step-description {
  color: #5f6368;
  margin-bottom: 25px;
  font-size: 14px;
}

.cc-section {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 25px;
}

.cc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e8eaed;
}

.cc-header h4 {
  margin: 0;
  font-size: 18px;
  color: #202124;
  display: flex;
  align-items: center;
  gap: 10px;
}

.cc-header h4 i {
  color: #1a73e8;
}

.cc-count {
  background: #e8f0fe;
  color: #1a73e8;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 600;
}

.cc-input-group {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.cc-input {
  flex: 1;
  padding: 10px 15px;
  border: 1px solid #dadce0;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.cc-input:focus {
  outline: none;
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn-primary {
  background: #1a73e8;
  color: white;
}

.btn-primary:hover {
  background: #1557b0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-primary:active {
  transform: scale(0.98);
}

.btn-secondary {
  background: #5f6368;
  color: white;
}

.btn-secondary:hover {
  background: #4a4d50;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-secondary:active {
  transform: scale(0.98);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn:disabled:hover {
  box-shadow: none;
  transform: none;
}

.cc-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cc-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border: 1px solid #e8eaed;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.cc-item:hover {
  background: #f1f3f4;
  border-color: #dadce0;
}

.cc-email {
  font-size: 14px;
  color: #202124;
  font-family: 'Roboto Mono', monospace;
}

.btn-remove-cc {
  background: #ea4335;
  color: white;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
}

.btn-remove-cc:hover {
  background: #d33426;
  transform: scale(1.05);
}

.btn-remove-cc:active {
  transform: scale(0.95);
}

.cc-empty {
  padding: 30px;
  text-align: center;
  color: #5f6368;
  font-size: 14px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px dashed #dadce0;
}
</style>
